module.exports = require('./StringChangeDetector').StringChangeDetector;
